import {
  getIsMobileAgent,
  getWindow,
} from '@bifrost-platform/bifront-sdk-react-biholder';
import { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { MEDIA_QUERY_MOBILE } from '@/configs/mediaQuery';

export default function useIsMobile() {
  // initial value
  const initialValue = (getWindow()?.innerWidth ?? 0) <= 800;

  // state
  const [isMobileAgent, setIsMobileAgent] = useState(initialValue);

  // media query
  const mediaQueryValue = useMediaQuery({
    query: `(${MEDIA_QUERY_MOBILE})`,
  });

  // effect
  useEffect(() => {
    const handleResize = () => {
      setIsMobileAgent(getIsMobileAgent());
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [mediaQueryValue]);

  return isMobileAgent;
}
